import { useEffect, useState } from "react";

const BASE_URL = "https://be-ofertas.utpl.edu.ec";

const DataFetcherTemplateHome = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 Obtener UNA imagen
  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId,
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url
      ? BASE_URL + file.attributes.uri.url
      : null;
  };

  // 🔥 Obtener MUCHAS imágenes
  const getImageUrls = (node, included, fieldName) => {
    const mediaItems = node.relationships?.[fieldName]?.data;
    if (!Array.isArray(mediaItems)) return [];

    return mediaItems
      .map((item) => {
        const media = included.find(
          (inc) => inc.type === "media--image" && inc.id === item.id,
        );

        const fileId = media?.relationships?.field_media_image?.data?.id;

        const file = included.find(
          (inc) => inc.type === "file--file" && inc.id === fileId,
        );

        return file?.attributes?.uri?.url
          ? BASE_URL + file.attributes.uri.url
          : null;
      })
      .filter(Boolean);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Error ${response.status}`);

        const json = await response.json();

        console.log("API RESPONSE:", json); // 👈 debug

        // ✅ CORRECCIÓN: data puede ser array
        const node = Array.isArray(json?.data) ? json.data[0] : json.data;

        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        // 🔥 Imagen principal
        const imagePortada = getImageUrl(
          node,
          included,
          "field_imagen_portada",
        );

        const cleanData = {
          id: node.id,
          titulo: atributos.title,
          texto_portada: atributos.field_texto_portada?.processed,
          bloque1: atributos.field_bloque1?.processed,
          bloque2: atributos.field_bloque2?.processed,
          bloque3: atributos.field_bloque3?.processed,
          bloque4: atributos.field_bloque4?.processed,
          bloque5: atributos.field_bloque5?.processed,
          bloque6: atributos.field_bloque6?.processed,
          bloque7: atributos.field_bloque7?.processed,
          bloque8: atributos.field_bloque8?.processed,
          bloque9: atributos.field_bloque9?.processed,
          bloque10: atributos.field_bloque10?.processed,
          bloque11: atributos.field_bloque11?.processed,
          bloque12: atributos.field_bloque12?.processed,
          bloque13: atributos.field_bloque13?.processed,
          bloque14: atributos.field_bloque14?.processed,
          bloque15: atributos.field_bloque15?.processed,
          bloque16: atributos.field_bloque16?.processed,
          bloque17: atributos.field_bloque17?.processed,
          bloque18: atributos.field_bloque18?.processed,
          bloque19: atributos.field_bloque19?.processed,
          bloque20: atributos.field_bloque20?.processed,
          bloque21: atributos.field_bloque21?.processed,
          bloque22: atributos.field_bloque22?.processed,
              bloque23: atributos.field_bloque23?.processed,
          bloque24: atributos.field_bloque24?.processed,
          bloque25: atributos.field_bloque25?.processed,
          // ✅ Imagen lista
          imagen_portada: imagePortada || "",

          // ✅ Galería
          galeria: getImageUrls(node, included, "field_gallery"),
        };

        setData(cleanData);
      } catch (err) {
        console.error("FETCH ERROR:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcherTemplateHome;
